const _NoUserMenu = [
  {
    text: 'logInSession',
    link: '/login',
    openInDiferentPage: false
  },
  {
    text: 'createAccount',
    link: '/register',
    openInDiferentPage: false
  }
];

exports.getNoUserMenuData = function () {
  return _NoUserMenu;
};
